/** Stable BE slug when simulate inflight / comparison slots are exhausted. */
export const POLICY_SIMULATE_INFLIGHT_SLUG = "policy.simulate.inflight";

export function isSimulateInflightErrorSlug(slug: string | undefined): boolean {
  return slug === POLICY_SIMULATE_INFLIGHT_SLUG;
}

export function simulateInflightToastCopy(options?: {
  forReport?: boolean;
  backendMessage?: string;
}): { title: string; description: string } {
  const title = options?.forReport
    ? "Max sims reached for this report"
    : "Max simulations running";
  const description =
    options?.backendMessage?.trim() || "Remove a simulation to run more.";
  return { title, description };
}

export function reportComparisonLimitToastCopy(): { title: string; description: string } {
  return {
    title: "Max sims reached for this report",
    description: "Remove a simulation to run more.",
  };
}

export function simulationRunSavedAsStrategyVersionToastCopy(): {
  title: string;
  description: string;
} {
  return {
    title: "Simulation run saved",
    description: "Your simulation run was saved as a strategy version.",
  };
}
